import styled from "styled-components";
import { Colors } from "../colors/colors";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 10px;
  gap: 16px;
  width: 90vw;
`;

export const ModalWrapper = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
`;

export const ModalFormContent = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  overflow: auto;
`;

export const ModalFormContainer = styled.div`
  border: 1px solid #dee2e6;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
  position: relative;
`;

export const ContainerWithBorder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${Colors.borderColorModalBody};
  padding: 32px;
  gap: 16px;
`;

// export const ModalContainer = styled.div<{ show: boolean }>`
//   display: ${({ show }) => (show ? "flex" : "none")};
//   justify-content: center;
//   align-items: flex-start; /* Alinha o modal ao topo */
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.5);
//   z-index: 1000;
//   animation: slideDown 0.3s ease;
//   overflow-y: auto; /* Rolagem no container */
//   padding: 2rem;
//   box-sizing: border-box;

//   @keyframes slideDown {
//     from {
//       transform: translateY(-100%);
//     }
//     to {
//       transform: translateY(0);
//     }
//   }
// `;

// export const ModalContent = styled.div`
//   background-color: ${Colors.white};
//   border-radius: 4px;
//   display: flex;
//   flex-direction: column;
//   align-self: center;
//   padding: 64px;
//   gap: 16px;
//   position: relative;
//   box-sizing: border-box;
//   padding-bottom: 64px;
//   width: auto;
//   max-height: 90%; /* Altura máxima fixa, ajustável conforme necessário */
//   overflow-y: auto; /* Adiciona scroll interno vertical */
//   overflow-x: hidden; /* Evita scroll horizontal */
// `;

// export const ModalBody = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   padding: 32px;
//   background-color: ${Colors.backgroundColorModalBody};
//   border: 1px solid ${Colors.borderColorModalBody};
//   border-radius: 4px;
//   flex-grow: 1; /* Permite que o conteúdo se expanda para o restante da altura */
//   width: 100%; /* Garante que o ModalBody ocupe toda a largura disponível */
//   height: 100%; /* Garante que o ModalBody ocupe toda a altura disponível */
// `;


export const ModalContainer = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh; /* Usa altura da viewport */
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  padding: 1rem; /* Padding reduzido */
  box-sizing: border-box;
  overflow: hidden; /* Sem scroll no container */

  @media (max-width: 768px) {
    padding: 0.5rem; /* Menos padding em telas menores */
  }

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const ModalContent = styled.div<{ height?: number, width?: number }>`
  background-color: ${Colors.white};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-self: center;
  padding: 2rem;
  position: relative;
  box-sizing: border-box;



  height: ${(props) => props.height ? `${props.height}vh` : "auto"};
  max-height: ${(props) => props.height ? `${props.height}vh` : "95vh"};

  width: ${(props) => props.width ? `${props.width}vw` : "auto"};
  max-width: ${(props) => props.width ? `${props.width}vw` : "95vw"};

  @media (max-width: 768px) {
    padding: 1rem;
    min-width: 100vh;
    max-width: 95%;
  }
`;
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${Colors.borderColorModalBody};
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

export const ModalBody = styled.div<{ height?: number, width?: number }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  margin-top: 0.5rem;
  background-color: ${Colors.backgroundColorModalBody};
  border: 1px solid ${Colors.borderColorModalBody};
  border-radius: 4px;
  overflow-y: auto; /* Scroll interno vertical */
  overflow-x: hidden; /* Sem scroll horizontal */
  box-sizing: border-box;

  width: ${(props) => props.width ? `${props.width}vw` : "100%"}; /* Ocupa toda a largura disponível do ModalContent */
  height: ${(props) => props.height ? `${props.height}vh` : "100%"};
  max-height: ${(props) => props.height ? `${props.height}vh` : "100%"}; /* Altura máxima para o ModalBody */

  @media (max-width: 768px) {
    padding: 1rem;
    max-height: 100%; /* Altura menor em telas pequenas */
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end; /* Alinha botões à direita */
  gap: 1rem; /* Espaço entre botões */
  padding: 1rem 0;
  box-sizing: border-box;
  width: 100%; /* Ocupa toda a largura do ModalContent */
  position: relative; /* Garante que não seja afetado pelo scroll */
  @media (max-width: 768px) {
    padding: 0.5rem;
    gap: 0.5rem; /* Menos espaço entre botões em telas menores */
    flex-wrap: wrap; /* Permite quebra de linha em telas pequenas */
  }
`;

export const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 1rem; /* Reduzido para melhor uso do espaço */
  right: 1rem; /* Reduzido para melhor uso do espaço */
  z-index: 10; /* Garante que o botão fique acima do ModalBody */

  @media (max-width: 768px) {
    top: 0.5rem; /* Menos espaço em telas menores */
    right: 0.5rem;
  }
`;

export const ModalBodyContainer = styled.div<{ width?: string, heigth?: string }>`
  width:  ${({ width }) => (width ? width : "auto")};
  heigth:  ${({ heigth }) => (heigth ? heigth : "auto")};
   display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`
export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  margin-bottom: 4px;
`;

export const BlueTitle = styled.h1<{ fontSize?: number, marginBottom?: number }>`
  margin: 0;
  width: 100%;
  max-height: 20px;
  font-weight: 500;
  font-size: ${(props) => props.fontSize || 20}px;
  line-height: 20px;
  margin-bottom: ${(props) => props.marginBottom || 18}px;
  color: ${Colors.primary};
`;

export const GrayTitle = styled.h1`
  margin: 0;
  width: 100%;
  max-height: 20px;
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: #4b5563;
`;

export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RequiredFields = styled.div`
  color: ${Colors.danger};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
`;

export const TextError = styled.span`
  color: ${Colors.error};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
`;

export const StyledHR = styled.hr`
  margin: 0;
  border: 1px solid ${Colors.styledHR};
  opacity: 1;
`;

export const Column = styled.div<{ basis?: string }>`
  display: flex;
  flex-direction: column;
  
  flex-basis: ${({ basis }) => basis || "100%"};
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  @media (max-width: 1280px) {
    flex-direction: column;
  }
`;

export const ButtonGroupStart = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
`;

export const ButtonGroupEnd = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const LoadingGif = styled.img`
  width: 100px;
  height: 100px;
`;
export const Space = styled.div`
  height: 15px;
`;

/* Estilo global para placeholders */
export const PlaceholderStyle = styled.div`
  &::placeholder, input::placeholder, select::placeholder, .date-picker-input::placeholder {
    color: ${Colors.placeholder};
  }
`;
